import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();

  const menus = [
    {
      title: "Dashboard",
      path: "/admin/dashboard",
    },
    {
      title: "Users",
      path: "/admin/users",
    },
    {
      title: "Deposits",
      path: "/admin/deposits",
    },
    {
      title: "Investments",
      path: "/admin/investments",
    },
    {
      title: "Withdrawals",
      path: "/admin/withdrawals",
    },
    {
      title: "Level Income",
      path: "/admin/level-income",
    },
  ];

  return (
    <div
      style={{
        width: 240,
        background: "#111827",
        minHeight: "100vh",
        color: "#fff",
        padding: 20,
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: 30,
        }}
      >
        ALGOXPO ADMIN
      </h2>

      {menus.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{
            display: "block",
            textDecoration: "none",
            color: "#fff",
            padding: 12,
            marginBottom: 10,
            borderRadius: 8,
            background:
              location.pathname === item.path ? "#2563eb" : "#1f2937",
          }}
        >
          {item.title}
        </Link>
      ))}

      <button
        onClick={() => {
          localStorage.removeItem("adminToken");
          window.location.href = "/admin/login";
        }}
        style={{
          marginTop: 40,
          width: "100%",
          padding: 12,
          background: "#dc2626",
          color: "#fff",
          border: 0,
          borderRadius: 8,
          cursor: "pointer",
        }}
      >
        Logout
      </button>
    </div>
  );
}
